import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppService } from './app.service';
import { environment } from '../environments/environment.demo'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'industry-x-developer-hub';
  isIframe = false;
  loginDisplay = false;
  loginUserData: any;
  username: any
  email_id: any
  private readonly _destroying$ = new Subject<void>();


  requesttoken: SilentRequest = {
    scopes: [environment.clientId + '/user.read'],
    account: undefined,
    // account: this.msalService.instance.getAllAccounts()[0]
  };

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private _appService: AppService
  ) { }


  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.isIframe = window !== window.parent && !window.opener;
    // console.log("this.msalBroadcastService.inProgress$", this.msalBroadcastService.inProgress$)
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => { console.log("status", status); return status === InteractionStatus.None }),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.loginUserData = this.authService.instance.getAllAccounts();
        this.username = this.loginUserData[0].username
        this.username = this.username.slice(0, this.username.indexOf("@"));
        this._appService.setUsername(this.username)
        this.email_id = this.username + "@accenture.com"
        this._appService.insertUserDetails().subscribe((res) => {
        })


        this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
        this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
          // console.log("SilentToken response", result);
          sessionStorage.setItem('accessToken', result.accessToken);
          this._appService.jwtAuthorizationToken=result.accessToken;
          //console.log("this.jwtAuthorizationToken component file", this._appService.jwtAuthorizationToken);
        })

        if (!sessionStorage.getItem('accessToken')) {
          this._appService.getMSALTokenExplicitly().subscribe(res => {
            // console.log("Explicit response for MSAL", res)
            // sessionStorage.setItem('accessToken', res.accessToken);
          })
        }

      });


  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      // console.log("this.msalGuardConfig", this.msalGuardConfig);

      // console.log(" this.msalGuardConfig.authRequest : ", this.msalGuardConfig.authRequest)
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
